import { Flex, Spinner } from '@chakra-ui/react';
import React from 'react';

const LoadingOverlay = () => {
  return (
    <Flex
      position={'absolute'}
      inset={0}
      zIndex={'999'}
      background={'gray.100'}
      opacity={0.5}
      justify={'center'}
      align={'center'}
    >
      <Spinner color="primary" />
    </Flex>
  );
};

export default LoadingOverlay;
